export const setData = (data) => ({
    type: 'SET_DATA',
    payload: data,
  });
  
  export const setDataSuccess = (data) => ({
    type: 'SET_DATA_SUCCESS',
    payload: data,
  });